module.exports = __webpack_public_path__ + "img/main_bmp.45bfbb17.png";